import React, { FunctionComponent, memo } from 'react'
import { Redirect, Route, RouteProps } from 'react-router'
import { shallowEqual } from 'react-redux'

export interface ProtectRule {
    check: () => boolean | undefined | null,
    redirect: string,
}

export interface ProtectedRouteProps extends RouteProps{
    rules: ProtectRule[],
}

const ProtectedRoute: FunctionComponent<ProtectedRouteProps> = (props) => {
    for(const rule of props.rules) {
        if (!rule.check()) {
            return <Redirect to={rule.redirect}/>
        }
    }
    return <Route {...props}/>
}

export default memo(ProtectedRoute, shallowEqual)


